
import { Component, Vue, Prop } from "vue-property-decorator";
import { MR } from "@/store/modules";
import { mapGetters } from "vuex";
import { mixins } from "vue-class-component";
import { MRErrorMixin } from "./MRErrorMixin";

@Component({
  /*computed: {
    ...mapGetters('entities/mr', {
      record: 'getErrors'
    })
  }*/
})
export class MRVoidButton extends mixins(MRErrorMixin) {
  @Prop(MR)
  private record!: MR;

  @Prop(Boolean)
  loading = false;

  savingText = "Saving";

  get isVoided() {
    // return false;
    return this.record.voided;
  }

  get text() {
    return this.record.voided ? "Reinstate Voided" : "Void";
  }

  onClick() {
    this.$bvModal
      .msgBoxConfirm(`Are you sure you want to ${this.text} this MR?`, {
        title: "Please Confirm",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        hideHeaderClose: true,
        centered: true,
      })
      .then((state: boolean) => {
        if (!state) {
          return;
        }
        return this.$nextTick(() => this.voidMR());
      });
  }

  async voidMR() {
    // this.loading = true;
    try {
      await MR.dispatch("markVoid", {
        id: this.record.id,
      });
    } catch (err) {
      console.error("Error occured", err, this);
    }

    // if (!this.hasError()) {
    //   this.$root.$bvToast.toast(`Record has been updated`, {
    //     title: "Saving",
    //     variant: "success",
    //   });
    //   this.loading = false;
    //   return;
    // }

    // this.$root.$bvToast.toast(`Failed to save MR`, {
    //   title: "Error",
    //   variant: "danger",
    // });

    // this.loading = false;
  }
}

export default MRVoidButton;
